import Phaser from 'phaser';
import { COLORS } from 'helpers/constants';

export default class HighscoreModal extends Phaser.Scene {
  constructor() {
    super('HighscoreModalScene');
  }
  init(data) {
    this.done = data.done;
    this.levelId = data.levelId;
    this.highScoresResponse = data.highScoresResponse;
    this.isControllerInput = data.isControllerInput;
    this.scale.on('resize', this.resize);
    this.events.on('shutdown', () => {
      this.scale.off('resize', this.resize);
    });
  }
  resize = () => {
    const cam = this.cameras.main;
    const scale = this.game.defaultZoom;
    const centerX = parseInt(cam.centerX);
    const centerY = parseInt(cam.centerY);

    this.backdropRect = new Phaser.Geom.Rectangle(
      0,
      0,
      window.innerWidth,
      window.innerHeight
    );

    this.backdrop.clear();
    this.backdrop.fillStyle(0x1f272c, 0.5);
    this.backdrop.fillRectShape(this.backdropRect);

    this.bg.setPosition(centerX, centerY).setScale(scale);

    if (this.highScoresTextObject) {
      this.highScoresTextObject
        .setPosition(centerX - 104 * scale, centerY - 104 * scale)
        .setStyle({
          fontSize: `${16 * scale}px`
        });
    }
    if (this.playerBestTextObject) {
      this.playerBestTextObject
        .setPosition(centerX - 104 * scale, centerY + 101 * scale)
        .setStyle({
          fontSize: `${16 * scale}px`
        });
    }
    if (this.errorTextObject) {
      this.errorTextObject
        .setPosition(centerX - 104 * scale, centerY - 104 * scale)
        .setStyle({
          fontSize: `${16 * scale}px`
        });
    }
  };
  closeModal = () => {
    this.backdrop.disableInteractive();
    this.done();
  };
  async create() {
    this.scene.bringToTop();
    const scale = this.game.defaultZoom;
    const cam = this.cameras.main;
    const centerX = parseInt(cam.centerX);
    const centerY = parseInt(cam.centerY);

    this.backdropRect = new Phaser.Geom.Rectangle(
      0,
      0,
      window.innerWidth,
      window.innerHeight
    );

    this.backdrop = this.add.graphics();
    this.backdrop.fillStyle(0x1f272c, 0.5);
    this.backdrop.fillRectShape(this.backdropRect);
    this.backdrop.on('pointerup', this.closeModal);

    this.bg = this.add
      .sprite(centerX, centerY, 'ui_freeplay_leaderboard_bg')
      .setScale(scale)
      .setInteractive()
      .on('pointerup', this.closeModal);

    //todo - set this once we want to let the user click...
    this.backdrop.setInteractive(
      this.backdropRect,
      Phaser.Geom.Rectangle.Contains
    );

    if (this.highScoresResponse) {
      this.highScores = this.highScoresResponse.highScores;
      this.playerRank = this.highScoresResponse.playerRank;
      this.error = this.highScoresResponse.error;
    }

    if (this.error) {
      console.log(this.error);
      const errorMessage =
        this.error.toString().search('TypeError: Failed to fetch') !== -1
          ? 'We were unable to connect to the Super Chesslike server to fetch high scores. Please try again later.'
          : this.error;
      this.errorTextObject = this.add
        .text(centerX - 104 * scale, centerY - 104 * scale, errorMessage, {
          fontSize: `${16 * scale}px`,
          color: COLORS.LIGHT_YELLOW,
          fontWeight: 'bold',
          fontFamily: 'PixelOperatorBold',
          textAlign: 'center',
          wordWrap: { width: 208 * scale }
        })
        .setOrigin(0);
      return;
    }

    let scoreLineText = '';
    (this.highScores || []).forEach((highScore, index) => {
      console.log(highScore);
      const rankSuffix =
        index === 0 ? 'st' : index === 1 ? 'nd' : index === 2 ? 'rd' : 'th';
      const rankText = `${index + 1}${rankSuffix}`;
      const scoreIsEqualToAnotherAttempt = this.highScores.find(
        highScore2 =>
          highScore2.score === highScore.score &&
          highScore2.attempt_id !== highScore.attempt_id
      );
      const timeTieBreaker = scoreIsEqualToAnotherAttempt
        ? `(${highScore.time})`
        : '';
      scoreLineText += `${rankText}: ${highScore.score}${timeTieBreaker} - ${highScore.name}\n`;
    });
    this.highScoresTextObject = this.add
      .text(centerX - 104 * scale, centerY - 104 * scale, scoreLineText, {
        fontSize: `${16 * scale}px`,
        color: COLORS.LIGHT_YELLOW,
        fontWeight: 'bold',
        fontFamily: 'BitPap',
        textAlign: 'center'
      })
      .setOrigin(0);
    const playerRankSuffix =
      this.playerRank.player_rank === 1
        ? 'st'
        : this.playerRank.player_rank === 2
        ? 'nd'
        : this.playerRank.player_rank === 3
        ? 'rd'
        : 'th';
    const playerRankText = `${this.playerRank.player_rank}${playerRankSuffix}`;
    const playerBestText = `${playerRankText}: ${this.playerRank.name} - ${this.playerRank.score}`;

    this.playerBestTextObject = this.add
      .text(centerX - 104 * scale, centerY + 101 * scale, playerBestText, {
        fontSize: `${16 * scale}px`,
        color: COLORS.LIGHT_YELLOW,
        fontWeight: 'bold',
        fontFamily: 'BitPap',
        textAlign: 'center'
      })
      .setOrigin(0);
  }
}
